import React from 'react';
import Svg, {Path, Polygon} from 'react-native-svg';

interface Props {
  size?: number;
  color?: string;
}

const NovaCategoryWarningIcon: React.FC<Props> = ({
  size = 14,
  color = '#D97706',
}) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <Polygon
      points="10.29 3.86 1.82 18 22.18 18"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M12 9v4M12 17h.01"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default NovaCategoryWarningIcon;